import React, { Component } from 'react';
import { smoothScroll } from './lib/scroll';
import './Hero.css';

export default class Hero extends Component {
  handleContactMeClick = () => {
    const rect = document.getElementById('contact-me').getBoundingClientRect();
    smoothScroll(rect.top, 1000);
    const emailInput = document.getElementById('email');
    emailInput.focus();
  }

  render() {
    return (
      <section className="hero">
        <div className="title">
          <div className="header">
            <img className="avatar" src="/avatar.png" alt="avatar" />
            <div>
              <h1>
                I make games I want to play
                <br />and software to make my life easier.
              </h1>
              <div className="links">
                <a
                  className="link"
                  href="#contact-me"
                  onClick={(e) => { e.preventDefault(); this.handleContactMeClick(); }}
                  title="Contact me"
                >
                  contact
                </a>
                <span className="sep">/</span>
                <a
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/piinecone"
                  title="GitHub"
                >
                  github
                </a>
                <span className="sep">/</span>
                <a
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://store.steampowered.com/developer/piinecone"
                  title="Steam"
                >
                  steam
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
